import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getLeagueFixturesListStyles = (theme: Theme, windowWidth: number) => {
  const comfortable = windowWidth >= 768
  const spacious = windowWidth >= 1024
  const cardRadius = spacious ? 28 : comfortable ? 27 : 26

  return StyleSheet.create({
    card: {
      width: '100%',
      backgroundColor: theme.background.card,
      borderRadius: cardRadius,
      borderWidth: 1,
      borderColor: theme.gray[200],
      paddingVertical: 4,
      overflow: 'hidden',
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)' as const }
        : {
            shadowColor: theme.black,
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.08,
            shadowRadius: 16,
            elevation: 6,
          }),
    },
    emptyWrap: {
      paddingVertical: spacious ? 32 : 24,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      fontSize: spacious ? 14 : 13,
      color: theme.gray[500],
    },
    banner: {
      paddingHorizontal: spacious ? 20 : 16,
      paddingTop: spacious ? 16 : 12,
      paddingBottom: spacious ? 8 : 6,
      backgroundColor: theme.background.card,
    },
    bannerText: {
      fontSize: spacious ? 13 : 12,
      fontWeight: '700',
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      color: theme.primary,
    },
    /** Visible divider between consecutive games (replaces the shared row's faint internal border). */
    rowSeparator: {
      height: StyleSheet.hairlineWidth,
      marginHorizontal: spacious ? 20 : 16,
      backgroundColor: theme.gray[200],
    },
    loadMore: {
      marginTop: 4,
      marginHorizontal: spacious ? 16 : 12,
      marginBottom: spacious ? 12 : 10,
      paddingVertical: spacious ? 14 : 12,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.gray[100],
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    loadMorePressed: {
      opacity: 0.7,
    },
    loadMoreHover: {
      backgroundColor: theme.gray[200],
    },
    loadMoreText: {
      fontSize: spacious ? 14 : 13,
      fontWeight: '600',
      color: theme.primary,
    },
  })
}
